module.exports = __webpack_public_path__ + "static/media/afl-classic-ver-cen-white.2608e421.svg";